// src/components/logo/index.js
import { connect } from 'react-redux'
import { 
  getLogoSt,
  getLogoActive,
  getLogoHidden } from './selectors'
import {
  getViewportHeight,
  getViewportWidth
} from '../app/selectors'
import Logo from './logo'

const mapStateToProps = state => {
  return {
    st: getLogoSt(state),
    scrollActive: getLogoActive(state),
    scrollHidden: getLogoHidden(state),
    vw: getViewportWidth(state),
    vh: getViewportHeight(state)
  }
}

export default connect(mapStateToProps, null)(Logo)



// WEBPACK FOOTER //
// ./src/components/logo/index.js